import { render } from "./TournamentActivityList.vue?vue&type=template&id=51baa32b&scoped=true"
import script from "./TournamentActivityList.vue?vue&type=script&lang=js"
export * from "./TournamentActivityList.vue?vue&type=script&lang=js"

import "./TournamentActivityList.vue?vue&type=style&index=0&id=51baa32b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51baa32b"]])

export default __exports__